
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-214.69 0.331 956 956","width":"956","height":"956"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"1920","height":"970"}},[_c('path',{attrs:{"d":"M1920 10c0 254.608-101.14 498.788-281.18 678.823C1458.79 868.857 1214.61 970 960 970c-254.608 0-498.787-101.142-678.822-281.177C101.143 508.788 0 254.608 0 0h960l960 10z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)","transform":"translate(-696.69 -740.669)"}},[_c('circle',{attrs:{"cx":"960","cy":"1219","r":"478","fill":"#D6F3FF"}})])])
          )
        }
      }
    